export const REQUEST_START = "REQUEST_START";
export const SIGNUP_START = "SIGNUP_START";
export const REQUEST_ERROR = "REQUEST_ERROR";
export const SET_GAMES = "SET_GAMES";
export const SET_GAME = "SET_GAME";
export const RESET_GAME = "RESET_GAME";
export const GAME_SAVED = "GAME_SAVED";
export const SIGNUP_COMPLETE = "SIGNUP_COMPLETE";
